import { getRouteName, entities, routeTypes } from 'src/config/routeTypes'
/**
 * Admin views
 */

import DashboardLayout from 'src/views/admin/layout/DashboardLayout'
import PublicLayoutContent from 'src/views/public/ContentLayout'

/**
 * Dashboard
 */

const DashboardPage = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/dashboard/DashboardPage')
/**
 * Clients
 */
const ContactsLayout = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ContactsLayout')

const ClientDetails = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientDetails')
const ClientList = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientList')
const ClientDashboard = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientDashboard')
const ClientEdit = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientEdit')
const ClientFinancialEdit = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/clients/ClientManagement/ClientFinancialEdit')
const ClientCreate = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientCreate')
const ClientUsers = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientUsers')
const ClientJobs = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientJobs')
const ClientWebshop = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientWebshop')
const ClientOrders = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientOrders')
const ClientCredits = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientCredits')
const ClientInvoices = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientInvoices')
const ClientContracts = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientContracts')
const ClientProducts = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientProducts')
const ClientSubscriptions = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientSubscriptions')
const SubscriptionDetails = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/SubscriptionDetails')
const ClientLogs = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientLogs')
const ClientTokens = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ClientTokens')
const ReferenceThirdParties = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/contacts/clients/ClientManagement/ReferenceThirdParties')

/**
 * Jobs
 */
const JobCreate = () => import(/* webpackChunkName: "jobs" */ 'src/views/admin/jobs/JobCreate')
const JobDetails = () => import(/* webpackChunkName: "jobs" */ 'src/views/admin/jobs/JobDetails')
const JobDashboard = () => import(/* webpackChunkName: "jobs" */ 'src/views/admin/jobs/JobDetails/JobDashboard')
const JobEdit = () => import(/* webpackChunkName: "jobs" */ 'src/views/admin/jobs/JobDetails/JobEdit')
const JobApplicants = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/ApplicantList')
const JobLogs = () => import(/* webpackChunkName: "jobs" */ 'src/views/admin/jobs/JobDetails/JobLogs')
const JobActivation = () => import(/* webpackChunkName: "jobs" */ 'src/views/admin/jobs/JobDetails/JobActivation')
const JobList = () => import(/* webpackChunkName: "jobs" */ 'src/views/admin/jobs/JobList')
const JobAlertList = () => import(/* webpackChunkName: "jobs" */ 'src/views/admin/job-alerts/JobAlertList')
const JobAlertDetails = () => import(/* webpackChunkName: "jobs" */ 'src/views/admin/job-alerts/JobAlertDetails')

const ContentLayout = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/ContentLayout')
const CMSList = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/cms/CmsList')
const CmsCreate = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/cms/CmsCreate')
const CmsEdit = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/cms/CmsEdit')
const CmsDetails = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/cms/CmsDetails')
const LogList = () => import(/* webpackChunkName: "logs" */ 'src/views/admin/content/logs/LogList')

const NewsLetterList = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/newsletter/NewsLetterList')
const NewsLetterCreate = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/newsletter/NewsLetterCreate')
const NewsLetterEdit = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/newsletter/NewsLetterEdit')
const NewsLetterDetails = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/newsletter/NewsLetterDetails')

const LandingPagesList = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/landing-pages/LandingPagesList')
const LandingPageCreate = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/landing-pages/LandingPageCreate')
const LandingPageEdit = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/content/landing-pages/LandingPageEdit')

/**
 * Candidates
 */
const TalentLayout = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/talent/TalentLayout')
const Applicants = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/ApplicantList')
const Candidates = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/candidates/CandidateList')
const CandidateDetails = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/candidates/CandidateDetails')
const CandidateDashboard = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/candidates/CandidateDashboard')
const CandidateEdit = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/candidates/CandidateEdit')
const CandidateApplicants = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/candidates/CandidateApplicants')
const CandidateJobAlerts = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/candidates/CandidateJobAlerts')
const CandidateResumes = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/candidates/CandidateResumes')

/**
  Resumes
 */
const ResumeList = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/resumes/ResumeList')
const ResumeDetails = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/resumes/ResumeDetails')
const ResumeEdit = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/resumes/ResumeEdit')
const ResumeDashboard = () => import(/* webpackChunkName: "candidates" */ 'src/views/admin/talent/resumes/ResumeDashboard')

/**
 * Job Board
 */
const JobBoardList = () => import(/* webpackChunkName: "job-board" */ 'src/views/admin/content/job-board/JobBoardList')
const JobBoardDetails = () => import(/* webpackChunkName: "job-board" */ 'src/views/admin/content/job-board/JobBoardDetails')
const JobBoardDashboard = () => import(/* webpackChunkName: "job-board" */ 'src/views/admin/content/job-board/JobBoardDashboard')
const JobBoardSettings = () => import(/* webpackChunkName: "job-board" */ 'src/views/admin/content/job-board/JobBoardSettings')
const JobBoardOrders = () => import(/* webpackChunkName: "job-board" */ 'src/views/admin/content/job-board/JobBoardOrders')
const JobBoardLogs = () => import(/* webpackChunkName: "job-board" */ 'src/views/admin/content/job-board/JobBoardLogs')
const JobBoardJobs = () => import(/* webpackChunkName: "job-board" */ 'src/views/admin/content/job-board/JobBoardJobs')
const JobBoardLandingPages = () => import(/* webpackChunkName: "job-board" */ 'src/views/admin/content/job-board/JobBoardLandingPages')

/**
 * Organization
 */
const OrganizationList = () => import(/* webpackChunkName: "organization" */ 'src/views/admin/organization/OrganizationList')
const OrganizationCreate = () => import(/* webpackChunkName: "organization" */ 'src/views/admin/organization/OrganizationCreate')
const OrganizationEdit = () => import(/* webpackChunkName: "organization" */ 'src/views/admin/organization/OrganizationEdit')
const OrganizationJobs = () => import(/* webpackChunkName: "organization" */ 'src/views/admin/organization/OrganizationJobs')

/**
 * User
 */
const Profile = () => import(/* webpackChunkName: "user" */ 'src/views/admin/profile/UserProfile')
const ProfileDashboard = () => import(/* webpackChunkName: "user" */ 'src/views/admin/contacts/users/UserDetails/UserDetailsOverview')
const ProfileEdit = () => import(/* webpackChunkName: "user" */ 'src/views/admin/profile/EditProfileForm')
const ProfileEditPassword = () => import(/* webpackChunkName: "user" */ 'src/views/admin/contacts/users/UserDetails/UserDetailsPassword')
const ProfileLogs = () => import(/* webpackChunkName: "user" */ 'src/views/admin/contacts/users/UserDetails/UserDetailsLogs')

const UserDetails = () => import(/* webpackChunkName: "user" */ 'src/views/admin/contacts/users/UserDetails')
const UserCreate = () => import(/* webpackChunkName: "user" */ 'src/views/admin/contacts/users/UserCreate')
const UserList = () => import(/* webpackChunkName: "user" */ 'src/views/admin/contacts/users/UserList')
const UserDashboard = () => import(/* webpackChunkName: "user" */ 'src/views/admin/contacts/users/UserDetails/UserDetailsOverview')
const UserEdit = () => import(/* webpackChunkName: "user" */ 'src/views/admin/contacts/users/UserDetails/UserDetailsEdit')
const UserLogs = () => import(/* webpackChunkName: "user" */ 'src/views/admin/contacts/users/UserDetails/UserDetailsLogs')
/**
 * Settings
 */
const Settings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Settings')
const GeneralSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/GeneralSettings')
const JobSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/JobSettings')
const CandidateSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/CandidateSettings')
const SearchSuggestionsList = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/SearchSuggestions/SearchSuggestionsList')
const SearchSuggestionsDetails = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/SearchSuggestions/SearchSuggestionsDetails')
const SearchSuggestionsCreate = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/SearchSuggestions/SearchSuggestionsCreate')
const ThirdPartyList = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/ThirdParties/ThirdPartyList')
const ThirdPartyDetails = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/ThirdParties/ThirdPartyDetails')
const PlaceholdersList = () => import(/* webpackChunkName: settings */ 'src/views/admin/content/job-board/Placeholders/PlaceholdersList')
const PlaceholdersDetails = () => import(/* webpackChunkName: settings */ 'src/views/admin/content/job-board/Placeholders/PlaceholdersDetails')
const PlaceholdersCreate = () => import(/* webpackChunkName: settings */ 'src/views/admin/content/job-board/Placeholders/PlaceholdersCreate')
const ECommerceSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/ECommerceSettings')
const RoleSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/RoleSettings')
const SiteAdminsSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/SiteAdmins')
const SiteAdminsEdit = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/SiteAdmins/SiteAdminsEdit')
const SiteAdminsAdd = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/SiteAdmins/SiteAdminsAdd')
const EmailTemplateList = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Email/EmailTemplateList')
const EmailConfiguration = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Email/EmailConfiguration')
const EmailConfigurationAdd = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Email/EmailConfigurationAdd')
const EmailConfigurationEdit = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Email/EmailConfigurationEdit')
const EmailEdit = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Email/EmailEdit')
const EmailScheduleList = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Email/EmailScheduleList')
const EmailScheduleCreate = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Email/EmailScheduleCreate')
const EmailScheduleEdit = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Email/EmailScheduleEdit')
const RoleEditSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/RoleEditSettings')
const RoleAddSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/RoleEditSettings')
const CountrySettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/CountrySettings')
const LanguageSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/LanguageSettings')
const TranslationSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/TranslationSettings')
const CustomFieldsSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/CustomFieldsSettings')
const SegmentsSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Segment/SegmentList')
const SegmentCreate = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Segment/SegmentCreate')
const SegmentOverview = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Segment/SegmentOverview')
const ProductSettings = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Product/ProductList')
const PaymentTypeList = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Payment/PaymentTypeList')
const PaymentTypeDetails = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Payment/PaymentTypeDetails')
const ProductCreate = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Product/ProductCreate')
const ProductOverview = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Product/ProductOverview')
const ProductRuleCreate = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Product/ProductRuleCreate')
const ProductRuleEdit = () => import(/* webpackChunkName: settings */ 'src/views/admin/settings/Product/ProductRuleEdit')

/**
 *  E-commerce
 */
const ECommerceLayout = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/ECommerceLayout')
const OrderList = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/orders/OrderList')
const SubscriptionList = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/subscriptions/SubscriptionList')
const OrderDetails = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/orders/OrderDetails')
const CreditList = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/credits/CreditList')
const CreditLogs = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/credits/CreditLogs')
const ContractBalances = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/contracts/ContractBalances')
const ContractList = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/contracts/ContractList')
const ContractDetails = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/contracts/ContractDetails')
const BulkInvoices = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/administration/BulkInvoices')
const InvoiceLinesList = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/administration/InvoiceLines')
const InvoiceList = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/administration/invoices/InvoiceList')
const InvoiceDetails = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/administration/invoices/InvoiceDetails')
const InvoiceEdit = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/administration/invoices/InvoiceEdit')
const VoucherList = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/vouchers/VoucherList')
const VoucherCreate = () => import(/* webpackChunkName: ecommerce */ 'src/views/admin/e-commerce/vouchers/VoucherCreate')
const VoucherEdit = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/e-commerce/vouchers/VoucherEdit')
const VoucherDetails = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/e-commerce/vouchers/VoucherDetails')
const VoucherOrders = () => import(/* webpackChunkName: "clients" */ 'src/views/admin/e-commerce/vouchers/VoucherOrders')

/**
 * Reports
 */

const Reports = () => import(/* webpackChunkName: "reports" */ 'src/views/admin/reports/Reports')
const JobReports = () => import(/* webpackChunkName: "reports" */ 'src/views/admin/reports/JobReports')
const JobBoardReports = () => import(/* webpackChunkName: "reports" */ 'src/views/admin/reports/JobBoardReports')
const EcommerceReports = () => import(/* webpackChunkName: "reports" */ 'src/views/admin/reports/EcommerceReports')
const EcommerceJobBoardReports = () => import(/* webpackChunkName: "reports" */ 'src/views/admin/reports/EcommerceJobBoardReports')
const ClientReports = () => import(/* webpackChunkName: "reports" */ 'src/views/admin/reports/ClientReports')
const CandidateReports = () => import(/* webpackChunkName: "reports" */ 'src/views/admin/reports/CandidateReports')
const CreditReports = () => import(/* webpackChunkName: "reports" */ 'src/views/admin/reports/CreditReports')
const ContractReports = () => import(/* webpackChunkName: "reports" */ 'src/views/admin/reports/ContractReports')
/**
 * General views
 */
import NotFound from 'src/views/general/NotFoundPage'

/**
 * Public views
 */

const Login = () => import(/* webpackChunkName: auth */ 'src/views/public/Login')
const ForgotPassword = () => import(/* webpackChunkName: auth */ 'src/views/public/ForgotPassword')
const ResetPassword = () => import(/* webpackChunkName: auth */ 'src/views/public/ResetPassword')

import VueRouter from 'vue-router'

let token = localStorage.getItem('token')
let redirect = token ? '/jobs' : '/login'
const routes = [
  {
    path: '/',
    component: DashboardLayout,
    meta: {requiresAuth: true},
    redirect: redirect,
    children: [
      {
        path: 'dashboard',
        name: getRouteName(routeTypes.LIST, entities.DASHBOARD),
        component: DashboardPage
      },
      {
        path: 'jobs',
        name: getRouteName(routeTypes.LIST, entities.JOB),
        title: 'routes.titles.jobs',
        description: 'routes.descriptions.jobs',
        meta: {permission: 'admin-jobs-all'},
        component: JobList,
      },
      {
        path: 'jobs/create',
        name: getRouteName(routeTypes.CREATE, entities.JOB),
        title: 'routes.titles.createJob',
        description: 'routes.descriptions.createJob',
        meta: {permission: 'admin-jobs-crud'},
        props: true,
        component: JobCreate
      },
      {
        path: 'jobs/:id',
        name: getRouteName(routeTypes.DETAILS, entities.JOB),
        meta: {permission: 'admin-jobs-view'},
        component: JobDetails,
        redirect: 'jobs/:id/dashboard',
        children: [
          {
            path: 'dashboard',
            name: getRouteName('dashboard', entities.JOB),
            component: JobDashboard,
          },
          {
            path: 'edit',
            name: getRouteName('edit', entities.JOB),
            meta: {permission: 'admin-jobs-crud'},
            component: JobEdit,
          },
          {
            path: 'logs',
            name: getRouteName('logs', entities.JOB),
            component: JobLogs,
          },
          {
            path: 'applicants',
            name: getRouteName('applicants', entities.JOB),
            component: JobApplicants,
            props: route => ({
              jobId: route.params.id
            })
          },
          {
            path: 'activation',
            name: getRouteName('activation', entities.JOB),
            component: JobActivation,
          }
        ]
      },
      {
        path: '/talent',
        component: TalentLayout,
        name: 'talent',
        redirect: '/talent/candidates',
        children: [
          {
            path: 'candidates',
            name: getRouteName(routeTypes.LIST, entities.CANDIDATE),
            title: 'routes.titles.candidates',
            description: 'routes.descriptions.candidates',
            component: Candidates
          },
          {
            path: 'applicants',
            name: getRouteName(routeTypes.LIST, entities.APPLICANTS),
            title: 'routes.titles.applicants',
            description: 'routes.descriptions.applicants',
            component: Applicants
          },
          {
            path: 'job-alerts',
            name: getRouteName(routeTypes.LIST, entities.JOB_ALERT),
            title: 'routes.titles.jobAlerts',
            description: 'routes.descriptions.jobAlerts',
            component: JobAlertList,
          },
          {
            path: 'job-alerts/:id',
            name: getRouteName(routeTypes.DETAILS, entities.JOB_ALERT),
            component: JobAlertDetails,
          },
          {
            path: 'applicants-to-check',
            name: 'applicants_check_list',
            title: 'routes.titles.applicantsToCheck',
            description: 'routes.descriptions.applicantsToCheck',
            component: Applicants,
            props: {
              filters: [
                {
                  key: 'sort',
                  value: '-email'
                },
                {
                  key: 'match[status]',
                  value: 'check'
                }
              ]
            }
          },
          {
            path: 'resumes',
            name: getRouteName(routeTypes.LIST, entities.RESUME),
            title: 'routes.titles.resumes',
            description: 'routes.descriptions.resumes',
            component: ResumeList
          },
          {
            path: 'resumes/:id',
            name: getRouteName(routeTypes.DETAILS, entities.RESUME),
            component: ResumeDetails,
            redirect: 'resumes/:id/dashboard',
            children: [
              {
                path: 'dashboard',
                name: getRouteName('dashboard', entities.RESUME),
                component: ResumeDashboard,
              },
              {
                path: 'edit',
                name: getRouteName('edit', entities.RESUME),
                component: ResumeEdit,
              }
            ]
          },
          {
            path: 'candidates/:id',
            name: getRouteName(routeTypes.DETAILS, entities.CANDIDATE),
            component: CandidateDetails,
            redirect: 'candidates/:id/dashboard',
            children: [
              {
                path: 'dashboard',
                name: getRouteName('dashboard', entities.CANDIDATE),
                component: CandidateDashboard,
              },
              {
                path: 'edit',
                name: getRouteName('edit', entities.CANDIDATE),
                component: CandidateEdit,
              },
              {
                path: 'applicants',
                name: getRouteName('applicants', entities.CANDIDATE),
                component: CandidateApplicants,
              },
              {
                path: 'job-alerts',
                name: getRouteName('job-alerts', entities.CANDIDATE),
                component: CandidateJobAlerts,
              },
              {
                path: 'resumes',
                name: getRouteName('resumes', entities.CANDIDATE),
                component: CandidateResumes,
              }
            ]
          }
        ]
      },
      {
        path: '/content',
        component: ContentLayout,
        name: 'content',
        redirect: '/content/job-board',
        children: [
          {
            path: 'logs',
            name: getRouteName(routeTypes.LIST, entities.LOG),
            title: 'routes.titles.logs',
            description: 'routes.descriptions.logs',
            meta: {permission: 'admin-jobs-all'},
            component: LogList
          },
          {
            path: 'cms',
            name: getRouteName(routeTypes.LIST, entities.CMS),
            title: 'routes.titles.cms',
            description: 'routes.descriptions.cms',
            component: CMSList
          },
          {
            path: 'cms/create',
            name: getRouteName(routeTypes.CREATE, entities.CMS),
            component: CmsCreate
          },
          {
            path: 'cms/:id',
            name: getRouteName(routeTypes.DETAILS, entities.CMS),
            component: CmsDetails,
            redirect: 'cms/:id/edit',
            children: [
              {
                path: 'edit',
                name: getRouteName('edit', entities.CMS),
                component: CmsEdit
              }
            ]
          },
          {
            path: 'newsletter',
            name: getRouteName(routeTypes.LIST, entities.NEWSLETTER),
            title: 'routes.titles.newsletter',
            description: 'routes.descriptions.newsletter',
            component: NewsLetterList
          },
          {
            path: 'newsletter/create',
            name: getRouteName(routeTypes.CREATE, entities.NEWSLETTER),
            component: NewsLetterCreate
          },
          {
            path: 'newsletter/:id',
            name: getRouteName(routeTypes.DETAILS, entities.NEWSLETTER),
            component: NewsLetterDetails,
            redirect: 'newsletter/:id/edit',
            children: [
              {
                path: 'edit',
                name: getRouteName('edit', entities.NEWSLETTER),
                component: NewsLetterEdit
              }
            ]
          },
          {
            path: 'landing-pages',
            name: getRouteName(routeTypes.LIST, entities.LANDING_PAGE),
            title: 'routes.titles.landing-pages',
            description: 'routes.descriptions.landing-pages',
            component: LandingPagesList
          },
          {
            path: 'landing-pages/create',
            name: getRouteName(routeTypes.CREATE, entities.LANDING_PAGE),
            component: LandingPageCreate
          },
          {
            path: 'landing-pages/:id',
            name: getRouteName(routeTypes.DETAILS, entities.LANDING_PAGE),
            component: LandingPageEdit,
          },
          {
            path: 'job-board',
            name: getRouteName(routeTypes.LIST, entities.JOB_BOARD),
            title: 'routes.titles.jobBoard',
            description: 'routes.descriptions.jobBoard',
            meta: {permission: 'admin-jobboard-all'},
            component: JobBoardList
          },
          {
            path: 'job-board/:id',
            name: getRouteName(routeTypes.DETAILS, entities.JOB_BOARD),
            meta: {permission: 'admin-jobboard-view'},
            component: JobBoardDetails,
            redirect: 'job-board/:id/dashboard',
            children: [
              {
                path: 'dashboard',
                name: getRouteName('dashboard', entities.JOB_BOARD),
                component: JobBoardDashboard,
              },
              {
                path: 'settings',
                name: getRouteName('settings', entities.JOB_BOARD),
                meta: {permission: 'admin-jobboard-crud'},
                component: JobBoardSettings,
              },
              {
                path: 'logs',
                name: getRouteName('logs', entities.JOB_BOARD),
                component: JobBoardLogs,
              },
              {
                path: 'jobs',
                name: getRouteName('jobs', entities.JOB_BOARD),
                component: JobBoardJobs,
              },
              {
                path: 'landing-pages',
                name: getRouteName('landing-pages', entities.JOB_BOARD),
                component: JobBoardLandingPages,
              },
              {
                path: 'orders',
                name: getRouteName('orders', entities.JOB_BOARD),
                component: JobBoardOrders,
              },
              {
                path: 'placeholders',
                name: getRouteName('placeholders', entities.JOB_BOARD),
                component: PlaceholdersList
              },
              {
                path: 'placeholders/create',
                name: getRouteName(routeTypes.CREATE, entities.PLACEHOLDER),
                component: PlaceholdersCreate
              },
              {
                path: 'placeholders/:id',
                name: getRouteName(routeTypes.DETAILS, entities.PLACEHOLDER),
                component: PlaceholdersDetails
              },
            ]
          },
        ]
      },
      {
        path: '/organizations',
        name: getRouteName(routeTypes.LIST, entities.ORGANIZATION),
        title: 'routes.titles.organization',
        description: 'routes.descriptions.organization',
        meta: {permission: 'admin-jobs-all'},
        component: OrganizationList,
      },
      {
        path: '/organizations/create',
        name: getRouteName(routeTypes.CREATE, entities.ORGANIZATION),
        title: 'routes.titles.organizationCreate',
        description: 'routes.descriptions.organizationCreate',
        meta: {permission: 'admin-jobs-all'},
        component: OrganizationCreate
      },
      {
        path: '/organizations/:id',
        name: getRouteName(routeTypes.DETAILS, entities.ORGANIZATION),
        meta: {permission: 'admin-jobs-all'},
        component: OrganizationEdit
      },
      {
        path: '/organizations/:id/jobs',
        name: getRouteName('jobs', entities.ORGANIZATION),
        meta: {permission: 'admin-jobs-all'},
        component: OrganizationJobs
      },
      {
        path: '/contacts',
        component: ContactsLayout,
        name: 'contacts',
        redirect: '/contacts/clients',
        children: [
          {
            path: 'clients',
            name: getRouteName(routeTypes.LIST, entities.CLIENT),
            title: 'routes.titles.clients',
            description: 'routes.descriptions.clients',
            meta: {permission: 'admin-clients-all'},
            component: ClientList
          },
          {
            path: 'clients-to-check',
            name: 'clients_check_list',
            title: 'routes.titles.clientsToCheck',
            description: 'routes.descriptions.clientsToCheck',
            meta: {permission: 'admin-clients-all'},
            component: ClientList,
            props: {
              filters: [
                {
                  key: 'sort',
                  value: '-name'
                },
                {
                  key: 'match[status]',
                  value: 'check'
                }
              ]
            }
          },
          {
            path: 'clients/create',
            name: getRouteName(routeTypes.CREATE, entities.CLIENT),
            title: 'routes.titles.clientsCreate',
            description: 'routes.descriptions.clientsCreate',
            meta: {permission: 'admin-clients-crud'},
            component: ClientCreate
          },
          {
            path: 'clients/:id',
            name: getRouteName(routeTypes.DETAILS, entities.CLIENT),
            meta: {permission: 'admin-clients-view'},
            component: ClientDetails,
            redirect: 'clients/:id/dashboard',
            children: [
              {
                path: 'dashboard',
                name: getRouteName('dashboard', entities.CLIENT),
                component: ClientDashboard,
              },
              {
                path: 'edit',
                meta: {permission: 'admin-clients-crud'},
                name: getRouteName('edit', entities.CLIENT),
                component: ClientEdit,
              },
              {
                path: 'financial',
                meta: {permission: 'admin-clients-crud'},
                name: getRouteName('financial', entities.CLIENT),
                component: ClientFinancialEdit,
              },
              {
                path: 'users',
                name: getRouteName('users', entities.CLIENT),
                component: ClientUsers,
              },
              {
                path: 'jobs',
                name: getRouteName('jobs', entities.CLIENT),
                component: ClientJobs,
              },
              {
                path: 'webshop',
                name: getRouteName('webshop', entities.CLIENT),
                component: ClientWebshop,
              },
              {
                path: 'orders',
                name: getRouteName('orders', entities.CLIENT),
                component: ClientOrders,
              },
              {
                path: 'credits',
                name: getRouteName('credits', entities.CLIENT),
                component: ClientCredits,
              },
              {
                path: 'invoices',
                name: getRouteName('invoices', entities.CLIENT),
                component: ClientInvoices,
              },
              {
                path: 'contracts',
                name: getRouteName('contracts', entities.CLIENT),
                component: ClientContracts,
              },
              {
                path: 'products',
                name: getRouteName('products', entities.CLIENT),
                component: ClientProducts,
              },
              {
                path: 'subscriptions',
                name: getRouteName('subscriptions', entities.CLIENT),
                component: ClientSubscriptions,
              },
              {
                path: 'subscriptions/:subscriptionId',
                name: getRouteName('subscription-details', entities.SUBSCRIPTION),
                component: SubscriptionDetails
              },
              {
                path: 'contracts/:contractId',
                name: getRouteName('contract-details', entities.CLIENT),
                component: ContractDetails,
              },
              {
                path: 'logs',
                name: getRouteName('logs', entities.CLIENT),
                component: ClientLogs,
              },
              {
                path: 'tokens',
                name: getRouteName('tokens', entities.CLIENT),
                component: ClientTokens,
              },
              {
                path: 'third_parties',
                name: getRouteName('third_parties', entities.CLIENT),
                component: ReferenceThirdParties,
              }
            ]
          },
          {
            path: 'users',
            name: getRouteName(routeTypes.LIST, entities.USER),
            title: 'routes.titles.users',
            description: 'routes.descriptions.users',
            meta: {permission: 'admin-users-all'},
            component: UserList
          },
          {
            path: 'users/create',
            name: getRouteName(routeTypes.CREATE, entities.USER),
            title: 'routes.titles.usersCreate',
            description: 'routes.descriptions.usersCreate',
            meta: {permission: 'admin-users-crud'},
            component: UserCreate
          },
          {
            path: 'users/:id',
            name: getRouteName(routeTypes.DETAILS, entities.USER),
            meta: {permission: 'admin-users-view'},
            component: UserDetails,
            redirect: 'users/:id/dashboard',
            children: [
              {
                path: 'dashboard',
                name: getRouteName('dashboard', entities.USER),
                component: UserDashboard,
              },
              {
                path: 'edit',
                name: getRouteName('edit', entities.USER),
                meta: {permission: 'admin-users-crud'},
                component: UserEdit,
              },
              {
                path: 'logs',
                name: getRouteName('logs', entities.USER),
                component: UserLogs,
              }
            ]
          }
        ]
      },
      {
        path: 'profile/',
        name: 'profile',
        redirect: 'profile/dashboard',
        component: Profile,
        children: [
          {
            path: 'dashboard',
            name: 'profile_dashboard',
            title: 'routes.titles.profileDashboard',
            description: 'routes.descriptions.profileDashboard',
            component: ProfileDashboard,
          },
          {
            path: 'edit',
            name: 'profile_edit',
            title: 'routes.titles.profileEdit',
            description: 'routes.descriptions.profileEdit',
            component: ProfileEdit,
          },
          {
            path: 'password',
            name: 'profile_password',
            title: 'routes.titles.changePassword',
            description: 'routes.descriptions.changePassword',
            component: ProfileEditPassword,
          },
          {
            path: 'logs',
            name: 'profile_logs',
            component: ProfileLogs,
          }
        ]
      },
      {
        path: 'settings',
        name: getRouteName(routeTypes.DETAILS, entities.SETTINGS),
        meta: {permission: 'admin-settings-view'},
        component: Settings,
        redirect: 'settings/general',
        children: [
          {
            path: 'general',
            name: getRouteName('general', entities.SETTINGS),
            title: 'routes.titles.generalSettings',
            description: 'routes.descriptions.generalSettings',
            component: GeneralSettings
          },
          {
            path: 'jobs',
            name: getRouteName('job', entities.SETTINGS),
            title: 'routes.titles.jobSettings',
            description: 'routes.descriptions.jobSettings',
            component: JobSettings
          },
          {
            path: 'candidates',
            name: getRouteName('candidate', entities.SETTINGS),
            title: 'routes.titles.candidateSettings',
            description: 'routes.descriptions.candidateSettings',
            component: CandidateSettings
          },
          {
            path: 'search-suggestions',
            name: getRouteName('search-suggestions', entities.SETTINGS),
            title: 'routes.titles.searchSuggestions',
            description: 'routes.descriptions.searchSuggestions',
            component: SearchSuggestionsList
          },
          {
            path: 'search-suggestions/create',
            name: getRouteName(routeTypes.CREATE, entities.SUGGESTION),
            title: 'routes.titles.searchSuggestionsCreate',
            description: 'routes.descriptions.searchSuggestionsCreate',
            component: SearchSuggestionsCreate
          },
          {
            path: 'search-suggestions/:id',
            name: getRouteName(routeTypes.DETAILS, entities.SUGGESTION),
            component: SearchSuggestionsDetails
          },

          {
            path: 'third-parties',
            name: getRouteName('third-parties', entities.SETTINGS),
            title: 'routes.titles.thirdParties',
            description: 'routes.descriptions.thirdParties',
            component: ThirdPartyList
          },
          {
            path: 'third-parties/:id',
            name: getRouteName(routeTypes.DETAILS, entities.THIRD_PARTY),
            component: ThirdPartyDetails
          },
          {
            path: 'eCommerce',
            name: getRouteName('e_commerce', entities.SETTINGS),
            title: 'routes.titles.ecommerceSettings',
            description: 'routes.descriptions.ecommerceSettings',
            component: ECommerceSettings
          },
          {
            path: 'email',
            name: getRouteName('email', entities.SETTINGS),
            title: 'routes.titles.emailSettings',
            description: 'routes.descriptions.emailSettings',
            component: EmailTemplateList
          },
          {
            path: 'email-configuration',
            name: getRouteName('email-configuration', entities.SETTINGS),
            title: 'routes.titles.emailConfigurations',
            description: 'routes.descriptions.emailConfigurations',
            component: EmailConfiguration
          },
          {
            path: 'email-configuration/create',
            name: getRouteName(routeTypes.CREATE, entities.EMAIL_CONFIG),
            title: 'routes.titles.emailConfigurationsCreate',
            description: 'routes.descriptions.emailConfigurationsCreate',
            component: EmailConfigurationAdd
          },
          {
            path: 'email-configuration/:id',
            name: getRouteName(routeTypes.DETAILS, entities.EMAIL_CONFIG),
            component: EmailConfigurationEdit
          },
          {
            path: 'email/:id',
            name: getRouteName(routeTypes.DETAILS, entities.EMAIL),
            component: EmailEdit
          },
          {
            path: 'email-schedule',
            name: getRouteName('email-schedule', entities.SETTINGS),
            component: EmailScheduleList
          },
          {
            path: 'email-schedule/create',
            name: getRouteName(routeTypes.CREATE, entities.EMAIL_SCHEDULE),
            component: EmailScheduleCreate
          },
          {
            path: 'email-schedule/:id',
            name: getRouteName(routeTypes.DETAILS, entities.EMAIL_SCHEDULE),
            component: EmailScheduleEdit
          },
          {
            path: 'roles',
            name: getRouteName('roles', entities.SETTINGS),
            title: 'routes.titles.roles',
            description: 'routes.descriptions.roles',
            component: RoleSettings
          },
          {
            path: 'site-admins',
            name: getRouteName('site-admins', entities.SETTINGS),
            component: SiteAdminsSettings
          },
          {
            path: 'site-admins/create',
            name: getRouteName(routeTypes.CREATE, entities.SITE_ADMIN),
            component: SiteAdminsAdd
          },
          {
            path: 'site-admins/:id',
            name: getRouteName(routeTypes.DETAILS, entities.SITE_ADMIN),
            component: SiteAdminsEdit
          },
          {
            path: 'roles/create',
            name: getRouteName(routeTypes.CREATE, entities.ROLE),
            component: RoleAddSettings
          }, {
            path: 'roles/:id',
            name: getRouteName(routeTypes.DETAILS, entities.ROLE),
            component: RoleEditSettings
          },
          {
            path: 'country',
            name: getRouteName('country', entities.SETTINGS),
            title: 'routes.titles.countries',
            description: 'routes.descriptions.countries',
            component: CountrySettings
          },
          {
            path: 'language',
            name: getRouteName('language', entities.SETTINGS),
            title: 'routes.titles.languages',
            description: 'routes.descriptions.languages',
            component: LanguageSettings
          },
          {
            path: 'translations',
            name: getRouteName('translations', entities.SETTINGS),
            component: TranslationSettings
          },
          {
            path: 'custom_fields',
            name: getRouteName('custom_fields', entities.SETTINGS),
            component: CustomFieldsSettings
          },
          {
            path: 'segments-groups',
            name: getRouteName('segments-groups', entities.SETTINGS),
            title: 'routes.titles.segments',
            description: 'routes.descriptions.segments',
            component: SegmentsSettings
          },
          {
            path: 'segments-groups/create',
            name: getRouteName(routeTypes.CREATE, entities.SEGMENT_GROUP),
            title: 'routes.titles.segmentsCreate',
            description: 'routes.descriptions.segmentsCreate',
            component: SegmentCreate
          },
          {
            path: 'segments-groups/:id',
            name: getRouteName(routeTypes.DETAILS, entities.SEGMENT_GROUP),
            component: SegmentOverview
          },
          {
            path: 'products',
            name: getRouteName('products', entities.SETTINGS),
            title: 'routes.titles.products',
            description: 'routes.descriptions.products',
            component: ProductSettings
          },
          {
            path: 'payment-types',
            name: getRouteName('payment-types', entities.SETTINGS),
            title: 'routes.titles.paymentTypes',
            description: 'routes.descriptions.paymentTypes',
            component: PaymentTypeList
          },
          {
            path: 'payment-types/:id',
            name: getRouteName(routeTypes.DETAILS, entities.PAYMENT_TYPE),
            component: PaymentTypeDetails
          },
          {
            path: 'products/create',
            name: getRouteName(routeTypes.CREATE, entities.PRODUCT),
            title: 'routes.titles.productsCreate',
            description: 'routes.descriptions.productsCreate',
            component: ProductCreate
          },
          {
            path: 'products/:id',
            name: getRouteName(routeTypes.DETAILS, entities.PRODUCT),
            component: ProductOverview
          },
          {
            path: 'products/:id/rules/create',
            name: getRouteName(routeTypes.CREATE, entities.PRODUCT_RULE),
            component: ProductRuleCreate
          },
          {
            path: 'products/:id/rules/:ruleId',
            name: getRouteName(routeTypes.DETAILS, entities.PRODUCT_RULE),
            component: ProductRuleEdit
          }
        ]
      },
      {
        path: '/ecommerce',
        component: ECommerceLayout,
        redirect: '/ecommerce/orders',
        children: [
          {
            path: 'orders',
            name: getRouteName(routeTypes.LIST, entities.ORDER),
            title: 'routes.titles.orders',
            description: 'routes.descriptions.orders',
            component: OrderList
          },
          {
            path: 'subscriptions',
            name: getRouteName(routeTypes.LIST, entities.SUBSCRIPTION),
            component: SubscriptionList
          },
          {
            path: 'orders/:id',
            name: getRouteName(routeTypes.DETAILS, entities.ORDER),
            component: OrderDetails
          },
          {
            path: 'credits/balance',
            name: getRouteName(routeTypes.LIST, entities.CREDIT),
            title: 'routes.titles.creditBalance',
            description: 'routes.descriptions.creditBalance',
            component: CreditList
          },
          {
            path: 'credits/logs',
            name: getRouteName('credit-logs', entities.SETTINGS),
            title: 'routes.titles.creditLogs',
            description: 'routes.descriptions.creditLogs',
            component: CreditLogs
          },
          {
            path: 'contracts/balances',
            name: getRouteName('contract-balances', entities.CONTRACT),
            title: 'routes.titles.contractBalance',
            description: 'routes.descriptions.contractBalance',
            component: ContractBalances
          },
          {
            path: 'contracts',
            name: getRouteName(routeTypes.LIST, entities.CONTRACT),
            title: 'routes.titles.contracts',
            description: 'routes.descriptions.contracts',
            component: ContractList
          },
          {
            path: 'contracts/:id',
            name: getRouteName(routeTypes.DETAILS, entities.CONTRACT),
            component: ContractDetails
          },
          {
            path: 'invoices',
            name: getRouteName(routeTypes.LIST, entities.INVOICE),
            title: 'routes.titles.invoices',
            description: 'routes.descriptions.invoices',
            component: InvoiceList,
          },
          {
            path: 'invoices/:id',
            name: getRouteName(routeTypes.DETAILS, entities.INVOICE),
            component: InvoiceDetails,
            redirect: 'invoices/:id/edit',
            children: [
              {
                path: 'edit',
                name: getRouteName('', entities.INVOICE),
                component: InvoiceEdit,
              },
              {
                path: 'third_parties',
                name: getRouteName('third_parties', entities.INVOICE),
                component: ReferenceThirdParties,
              },
            ]
          },
          {
            path: 'bulk-invoices',
            name: getRouteName('bulk-invoices', entities.SETTINGS),
            title: 'routes.titles.bulkInvoices',
            description: 'routes.descriptions.bulkInvoices',
            component: BulkInvoices
          },
          {
            path: 'invoice-lines',
            name: getRouteName(routeTypes.LIST, entities.INVOICE_LINE),
            title: 'routes.titles.invoiceLines',
            description: 'routes.descriptions.invoiceLines',
            component: InvoiceLinesList
          },
          {
            path: 'vouchers',
            name: getRouteName(routeTypes.LIST, entities.VOUCHER),
            title: 'routes.titles.vouchers',
            description: 'routes.descriptions.vouchers',
            component: VoucherList
          },
          {
            path: 'vouchers/create',
            name: getRouteName(routeTypes.CREATE, entities.VOUCHER),
            title: 'routes.titles.vouchers',
            description: 'routes.descriptions.vouchers',
            component: VoucherCreate
          },
          {
            path: 'vouchers/:id',
            name: getRouteName(routeTypes.DETAILS, entities.VOUCHER),
            component: VoucherDetails,
            redirect: 'vouchers/:id/edit',
            children: [
              {
                path: 'edit',
                name: getRouteName('edit', entities.VOUCHER),
                component: VoucherEdit
              },
              {
                path: 'orders',
                name: getRouteName('orders', entities.VOUCHER),
                component: VoucherOrders,
              },
            ]
          },
        ]
      },
      {
        path: 'reports',
        name: getRouteName(routeTypes.LIST, entities.REPORT),
        title: 'routes.titles.reports',
        description: 'routes.descriptions.reports',
        meta: { permission: 'admin-settings-all'},
        component: Reports,
        redirect: 'reports/jobs-overview',
        children: [
          {
            path: 'jobs-overview',
            name: getRouteName(routeTypes.LIST, entities.JOB_REPORT),
            title: 'routes.titles.jobReports',
            description: 'routes.descriptions.jobReports',
            component: JobReports
          },
          {
            path: 'jobs',
            name: getRouteName(routeTypes.LIST, entities.JOB_BOARD_REPORT),
            title: 'routes.titles.jobBoards',
            description: 'routes.descriptions.jobBoards',
            component: JobBoardReports
          },
          {
            path: 'ecommerce-overview',
            name: getRouteName(routeTypes.LIST, entities.ECOMMERCE_REPORT),
            title: 'routes.titles.ecommerceReport',
            description: 'routes.descriptions.ecommerceReport',
            component: EcommerceReports
          },
          {
            path: 'ecommerce',
            name: getRouteName(routeTypes.LIST, entities.ECOMMERCE_JOB_BOARD_REPORT),
            component: EcommerceJobBoardReports
          },
          {
            path: 'clients',
            name: getRouteName(routeTypes.LIST, entities.CLIENT_REPORT),
            component: ClientReports,
          },
          {
            path: 'candidates',
            name: getRouteName(routeTypes.LIST, entities.CANDIDATE_REPORT),
            component: CandidateReports,
          },
          {
            path: 'credits',
            name: getRouteName(routeTypes.LIST, entities.CREDIT_REPORT),
            component: CreditReports,
          },
          {
            path: 'contracts',
            name: getRouteName(routeTypes.LIST, entities.CONTRACT_REPORT),
            component: ContractReports,
          },
        ]
      },
    ]
  },
  {
    path: '/',
    redirect: '/login',
    component: PublicLayoutContent,
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login
      },
      {
        path: '/forgot_password',
        name: 'forgotPassword',
        component: ForgotPassword
      },
      {
        path: '/reset_password',
        name: 'resetPassword',

        component: ResetPassword
      },
    ]
  },
  {path: '*', component: NotFound}
]

const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
})

export default router
